import React from 'react';
import { Container, Row } from 'reactstrap';
import OnaDailyPerformance from './components/OnaDailyPerformance';

export default function OnaDailyPerformancePage() {
  return (
    <Container className="dashboard">
      <Row>
        <OnaDailyPerformance />
      </Row>
    </Container>
  );
}
